export interface Video {
  id: string;
  title: string;
  description: string;
  category: string;
  coverImage: string;
  author: string;
  authorAvatar: string;
  publishDate: string;
  views: number;
  likes: number;
  comments: number;
  duration: string;
  content: string;
  tags: string[];
  isHot: boolean;
}

export const videos: Video[] = [
  {
    id: 'v001',
    title: '猫咪第一次见到雪的反应，太可爱了！',
    description: '南方猫咪第一次见到雪，兴奋到停不下来，萌化你的心~',
    category: 'dongwu',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fluffy%20orange%20cat%20playing%20in%20fresh%20white%20snow%20for%20the%20first%20time%2C%20excited%20expression%2C%20soft%20natural%20winter%20light%2C%20clean%20white%20background%2C%20shallow%20depth%20of%20field%2C%20cinematic%20warm%20tone%2C%20adorable%20pet%20photography&width=800&height=600&seq=mock-v001&orientation=landscape',
    author: '萌宠达人阿喵',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cat%20avatar%20icon%20minimalist%20flat%20design%20warm%20orange%20tone%20simple%20background&width=100&height=100&seq=mock-av001&orientation=squarish',
    publishDate: '2026-08-09',
    views: 1258000,
    likes: 89200,
    comments: 3200,
    duration: '00:45',
    content: '<p>南方猫咪"小橘"第一次见到雪，简直开心到飞起！</p><p>视频中小橘在雪地里打滚、追逐雪花，憨态可掬的样子让人忍俊不禁。主人表示，小橘平时很高冷，但看到雪后完全变成了另一个人格。</p><p>网友纷纷评论："这也太可爱了吧！""我家猫看到雪直接躲起来了""南方猫的快乐就是这么简单"。</p><p>温馨提示：带宠物接触雪地时要注意保暖哦，不要让它们在寒冷环境中待太久。</p>',
    tags: ['萌宠', '猫咪', '雪天', '可爱'],
    isHot: true,
  },
  {
    id: 'v002',
    title: '街边大爷的手艺绝了，这刀工我给满分',
    description: '街边小摊藏龙卧虎，大爷切豆腐的刀工惊呆路人',
    category: 'meishi',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20elderly%20Chinese%20street%20food%20vendor%20demonstrating%20incredible%20knife%20skills%20cutting%20tofu%20on%20a%20wooden%20board%2C%20steaming%20hot%20food%20stall%2C%20warm%20evening%20light%2C%20authentic%20street%20food%20photography%2C%20shallow%20depth%20of%20field%2C%20cinematic%20mood&width=800&height=600&seq=mock-v002&orientation=landscape',
    author: '美食猎人老王',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Food%20critic%20avatar%20icon%20minimalist%20flat%20design%20warm%20red%20tone%20simple%20background&width=100&height=100&seq=mock-av002&orientation=squarish',
    publishDate: '2026-08-08',
    views: 892000,
    likes: 67500,
    comments: 2100,
    duration: '01:20',
    content: '<p>在成都的一条小巷子里，藏着一家不起眼的豆腐摊。摊主是一位67岁的大爷，已经在这里做了30年的豆腐。</p><p>视频中，大爷展示了他惊人的刀工——一块嫩豆腐在他手中变成了一朵绽放的菊花，每片花瓣薄如蝉翼，却完整不碎。路人纷纷驻足拍摄，惊叹声此起彼伏。</p><p>大爷笑着说："这个不难，熟能生巧而已。"</p><p>这就是中国街头美食的魅力，平凡中见真功夫，简单中藏大智慧。</p>',
    tags: ['美食', '刀工', '街头美食', '豆腐', '成都'],
    isHot: true,
  },
  {
    id: 'v003',
    title: '上班族的午餐便当，一周不重样',
    description: '打工人必备！简单又美味的午餐便当合集，告别外卖',
    category: 'shenghuo',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautifully%20arranged%20colorful%20Japanese%20style%20bento%20lunch%20boxes%20on%20a%20clean%20white%20wooden%20table%2C%20fresh%20healthy%20ingredients%2C%20bright%20natural%20light%2C%20minimalist%20food%20photography%2C%20soft%20shadows%2C%20warm%20neutral%20background&width=800&height=600&seq=mock-v003&orientation=landscape',
    author: '便当小达人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Bento%20lover%20avatar%20icon%20minimalist%20flat%20design%20warm%20green%20tone%20simple%20background&width=100&height=100&seq=mock-av003&orientation=squarish',
    publishDate: '2026-08-07',
    views: 1560000,
    likes: 123400,
    comments: 5400,
    duration: '02:15',
    content: '<p>告别外卖！一周五天，每天都有一份精心准备的便当。</p><p>周一：照烧鸡腿便当，鸡腿腌制一晚入味，搭配西兰花和鸡蛋卷；周二：番茄牛腩便当，牛腩软烂入味，番茄酸甜开胃；周三：三文鱼牛油果便当，健康低脂又饱腹；周四：糖醋排骨便当，经典家常味道；周五：日式咖喱饭便当，一周辛苦工作的完美收官。</p><p>每份便当制作时间不超过30分钟，上班族也能轻松搞定！</p>',
    tags: ['便当', '午餐', '上班族', '美食', '生活'],
    isHot: true,
  },
  {
    id: 'v004',
    title: '2026秋季穿搭趋势，这5件单品必须有',
    description: '时尚博主带你解析今秋最in潮流元素',
    category: 'shishang',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20autumn%20fashion%20flat%20lay%20with%20beige%20trench%20coat%20leather%20boots%20and%20knitwear%20on%20warm%20wooden%20floor%2C%20soft%20natural%20autumn%20light%2C%20minimalist%20fashion%20photography%2C%20warm%20earthy%20tones%2C%20clean%20composition&width=800&height=600&seq=mock-v004&orientation=landscape',
    author: '时尚博主Lily',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Fashion%20blogger%20avatar%20icon%20minimalist%20flat%20design%20warm%20pink%20tone%20simple%20background&width=100&height=100&seq=mock-av004&orientation=squarish',
    publishDate: '2026-08-06',
    views: 678000,
    likes: 45600,
    comments: 1800,
    duration: '03:00',
    content: '<p>秋天来了，你的衣柜准备好了吗？</p><p>本期为大家带来2026秋季五大必入单品：1. 廓形西装外套——复古与新潮的完美结合；2. 高腰阔腿裤——显高显瘦的神器；3. 针织马甲——叠穿利器，增加层次感；4. 中筒切尔西靴——百搭又时髦；5. 羊绒围巾——质感提升的关键。</p><p>每一件单品都能轻松搭配出多种风格，让你的秋季穿搭不再单调！</p>',
    tags: ['时尚', '穿搭', '秋季', '潮流', '单品推荐'],
    isHot: true,
  },
  {
    id: 'v005',
    title: '小哥街头随机弹钢琴，路人反应破防了',
    description: '街头钢琴随机演奏，陌生人的合唱让人泪目',
    category: 'yinyue',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20young%20man%20playing%20a%20public%20piano%20on%20a%20busy%20city%20street%2C%20passersby%20stopping%20to%20listen%2C%20warm%20golden%20hour%20sunlight%2C%20emotional%20street%20photography%2C%20shallow%20depth%20of%20field%2C%20cinematic%20atmosphere&width=800&height=600&seq=mock-v005&orientation=landscape',
    author: '音乐在路上',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Musician%20avatar%20icon%20minimalist%20flat%20design%20warm%20blue%20tone%20simple%20background&width=100&height=100&seq=mock-av005&orientation=squarish',
    publishDate: '2026-08-05',
    views: 2340000,
    likes: 189000,
    comments: 8900,
    duration: '01:50',
    content: '<p>在深圳的一个地铁站里，放置着一架公共钢琴。一位年轻小伙坐下后开始弹奏《月亮代表我的心》。</p><p>起初只是路人驻足观望，渐渐地，有人开始跟着哼唱。一位阿姨走上前来，深情地唱起了这首歌，随后越来越多的人加入。现场变成了一场即兴的大合唱，歌声中充满了温暖和感动。</p><p>这就是音乐的力量——它能让陌生人之间瞬间产生共鸣，让冰冷的城市充满温度。</p>',
    tags: ['音乐', '街头表演', '钢琴', '感动', '合唱'],
    isHot: true,
  },
  {
    id: 'v006',
    title: '3分钟学会这道网红酸菜鱼，比饭店还好吃',
    description: '家庭版酸菜鱼教程，做法简单味道绝了',
    category: 'meishi',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20steaming%20hot%20bowl%20of%20Chinese%20Sichuan%20pickled%20fish%20soup%20with%20tender%20white%20fish%20fillets%20and%20pickled%20vegetables%2C%20garnished%20with%20chili%20and%20green%20onions%2C%20on%20a%20dark%20wooden%20table%2C%20warm%20lighting%2C%20appetizing%20food%20photography&width=800&height=600&seq=mock-v006&orientation=landscape',
    author: '厨房里的老王',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chef%20avatar%20icon%20minimalist%20flat%20design%20warm%20red%20tone%20simple%20background&width=100&height=100&seq=mock-av006&orientation=squarish',
    publishDate: '2026-08-04',
    views: 987000,
    likes: 76500,
    comments: 3100,
    duration: '03:30',
    content: '<p>酸菜鱼是一道家喻户晓的川菜，但很多人觉得在家做太复杂。今天老王就教你一个超简单的家庭版做法！</p><p>关键步骤：1. 鱼片用蛋清和淀粉腌制15分钟，这是嫩滑的秘诀；2. 酸菜一定要用开水焯一下，去除过重的咸味；3. 最后淋上一勺滚烫的花椒油，香气瞬间激发。</p><p>这样做出来的酸菜鱼，鱼肉嫩滑、汤汁酸爽，配上一碗白米饭，绝了！</p>',
    tags: ['美食', '酸菜鱼', '川菜', '家常菜', '教程'],
    isHot: false,
  },
  {
    id: 'v007',
    title: '搞笑合集：那些年我们做过的傻事',
    description: '看完笑到肚子疼，每一个都太真实了',
    category: 'gaoxiao',
    coverImage: 'https://readdy.ai/api/search-image?query=Funny%20compilation%20concept%20with%20colorful%20party%20elements%20confetti%20and%20laughing%20emotions%2C%20bright%20vibrant%20colors%2C%20playful%20and%20energetic%20atmosphere%2C%20clean%20minimal%20background%2C%20happy%20and%20joyful%20mood&width=800&height=600&seq=mock-v007&orientation=landscape',
    author: '笑点制造机',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Comedy%20avatar%20icon%20minimalist%20flat%20design%20bright%20yellow%20tone%20simple%20background&width=100&height=100&seq=mock-av007&orientation=squarish',
    publishDate: '2026-08-03',
    views: 3450000,
    likes: 256000,
    comments: 12400,
    duration: '02:40',
    content: '<p>人生就是一场大型搞笑合集，今天带大家回顾那些经典瞬间！</p><p>从走路撞到玻璃门、把盐当成糖放进咖啡、到在会议上不小心打开了自己的自拍——这些尴尬又搞笑的时刻，是不是也有你的影子？</p><p>笑一笑，十年少。生活虽然有时很囧，但回头看看，都是美好的回忆呀！</p>',
    tags: ['搞笑', '合集', '搞笑视频', '日常生活', '欢乐'],
    isHot: false,
  },
  {
    id: 'v008',
    title: '穿越可可西里，遇见中国最纯净的星空',
    description: '自驾穿越无人区，记录下震撼心灵的星空',
    category: 'lvxing',
    coverImage: 'https://readdy.ai/api/search-image?query=Stunning%20Milky%20Way%20galaxy%20night%20sky%20over%20snow%20capped%20mountains%20in%20Tibetan%20plateau%2C%20vast%20wilderness%20landscape%2C%20clear%20starry%20sky%20with%20thousands%20of%20stars%2C%20cinematic%20landscape%20photography%2C%20deep%20blue%20and%20purple%20tones&width=800&height=600&seq=mock-v008&orientation=landscape',
    author: '远方的风',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Traveler%20avatar%20icon%20minimalist%20flat%20design%20warm%20teal%20tone%20simple%20background&width=100&height=100&seq=mock-av008&orientation=squarish',
    publishDate: '2026-08-02',
    views: 567000,
    likes: 48900,
    comments: 1600,
    duration: '04:15',
    content: '<p>可可西里，中国最后的荒原。这里人迹罕至，却拥有地球上最纯净的星空。</p><p>这次自驾穿越历时5天，从格尔木出发，途经昆仑山口、沱沱河，最终到达可可西里腹地。当夜幕降临，海拔4500米的天空没有一丝光污染，银河清晰可见，仿佛触手可及。</p><p>站在这样的星空下，你会感受到人类的渺小和宇宙的浩瀚。这是一种无法用语言描述的震撼。</p>',
    tags: ['旅行', '可可西里', '星空', '自驾', '摄影'],
    isHot: false,
  },
  {
    id: 'v009',
    title: 'iPhone 18 Pro最新爆料，这升级太猛了',
    description: '下一代iPhone曝光，全息投影功能或将实现',
    category: 'keji',
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20smartphone%20concept%20with%20holographic%20display%20on%20a%20clean%20dark%20desk%2C%20minimalist%20tech%20product%20photography%2C%20soft%20neon%20glow%2C%20sleek%20modern%20design%2C%20dark%20gradient%20background&width=800&height=600&seq=mock-v009&orientation=landscape',
    author: '科技前沿站',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Tech%20reviewer%20avatar%20icon%20minimalist%20flat%20design%20cool%20gray%20tone%20simple%20background&width=100&height=100&seq=mock-av009&orientation=squarish',
    publishDate: '2026-08-01',
    views: 1890000,
    likes: 134000,
    comments: 6700,
    duration: '05:00',
    content: '<p>iPhone 17还没捂热，关于iPhone 18 Pro的爆料已经满天飞了！</p><p>据可靠消息，iPhone 18 Pro将搭载全新的A20 Pro芯片，采用3nm+工艺，性能提升40%。最让人期待的是，iPhone 18 Pro可能会引入全息投影功能，通过前置传感器阵列实现3D立体投影显示。</p><p>此外，摄像头系统也将迎来重大升级，主摄传感器尺寸进一步增大，低光拍摄能力提升200%。电池容量预计增加15%，配合更高效的芯片，续航有望突破2天。</p><p>当然，这些目前都只是爆料，具体情况还要等官方发布会揭晓。</p>',
    tags: ['科技', 'iPhone', '苹果', '手机', '爆料'],
    isHot: true,
  },
  {
    id: 'v010',
    title: 'NBA十佳球：字母哥隔扣三人，全场沸腾',
    description: '本周NBA精彩集锦，每一个进球都燃到爆',
    category: 'tiyu',
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20player%20performing%20a%20powerful%20dunk%20during%20an%20NBA%20game%2C%20dramatic%20arena%20lighting%2C%20excited%20crowd%20in%20background%2C%20action%20sports%20photography%2C%20dynamic%20motion%20blur%2C%20intense%20atmosphere&width=800&height=600&seq=mock-v010&orientation=landscape',
    author: '篮球狂热者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Basketball%20fan%20avatar%20icon%20minimalist%20flat%20design%20warm%20orange%20tone%20simple%20background&width=100&height=100&seq=mock-av010&orientation=squarish',
    publishDate: '2026-07-31',
    views: 2100000,
    likes: 167000,
    comments: 7800,
    duration: '02:10',
    content: '<p>本周NBA十佳球来了！准备好被震撼吧！</p><p>TOP 1 当之无愧属于字母哥——他在对阵凯尔特人的比赛中，从三分线起步，连过两人后隔扣第三名防守球员，全场瞬间沸腾！解说直接破音："THIS IS INSANE!!!"</p><p>TOP 2 库里在最后0.8秒的超远三分绝杀，TOP 3 詹姆斯的不看人背传助攻，每一个都是可以反复回看的经典时刻。</p><p>这就是NBA的魅力，每一秒都可能诞生奇迹！</p>',
    tags: ['NBA', '篮球', '十佳球', '体育', '精彩集锦'],
    isHot: true,
  },
  {
    id: 'v011',
    title: '学霸分享：考研数学满分的秘密',
    description: '清华学长亲授高效学习方法，看完醍醐灌顶',
    category: 'jiaoyu',
    coverImage: 'https://readdy.ai/api/search-image?query=Clean%20organized%20study%20desk%20with%20notebooks%20pens%20and%20a%20laptop%2C%20warm%20natural%20light%20from%20window%2C%20minimalist%20workspace%2C%20calm%20and%20focused%20atmosphere%2C%20soft%20shadows%2C%20neutral%20background&width=800&height=600&seq=mock-v011&orientation=landscape',
    author: '清华学长Leo',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Student%20avatar%20icon%20minimalist%20flat%20design%20warm%20blue%20tone%20simple%20background&width=100&height=100&seq=mock-av011&orientation=squarish',
    publishDate: '2026-07-30',
    views: 876000,
    likes: 98700,
    comments: 4500,
    duration: '06:20',
    content: '<p>考研数学满分，听起来很难？清华学长Leo用自己的经验告诉你：方法比努力更重要。</p><p>核心方法：1. 费曼学习法——用教别人的方式来检验自己是否真懂；2. 错题本的进阶用法——不是抄题，是分析错误类型并归类；3. 间隔重复——科学安排复习时间，把短期记忆转化为长期记忆。</p><p>Leo强调：不要和别人比进度，每个人的节奏不同。找到适合自己的方法，坚持执行，结果一定不会差。</p>',
    tags: ['教育', '考研', '学习方法', '数学', '清华'],
    isHot: false,
  },
  {
    id: 'v012',
    title: '原神5.0版本新角色实机演示，太帅了',
    description: '纳塔新角色技能展示，这特效拉满了',
    category: 'youxi',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20fantasy%20game%20character%20with%20fire%20element%20magical%20effects%2C%20dynamic%20action%20pose%2C%20vibrant%20orange%20and%20red%20colors%2C%20epic%20game%20art%20style%2C%20cinematic%20lighting%2C%20clean%20gradient%20background&width=800&height=600&seq=mock-v012&orientation=landscape',
    author: '游戏达人小陈',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Gamer%20avatar%20icon%20minimalist%20flat%20design%20warm%20purple%20tone%20simple%20background&width=100&height=100&seq=mock-av012&orientation=squarish',
    publishDate: '2026-07-29',
    views: 2780000,
    likes: 234000,
    comments: 15600,
    duration: '04:40',
    content: '<p>原神5.0版本"纳塔"即将上线，新角色的实机演示终于来了！</p><p>本次展示的五星火系角色拥有华丽的凤凰主题技能特效，元素战技可以召唤火焰凤凰对敌人造成大范围AOE伤害，元素爆发更是全屏火焰特效，帅到炸裂！</p><p>从演示来看，新角色的定位是站场主C，配合现有的夜兰、芙宁娜等辅助角色，有望成为新一代T0输出。不少玩家表示："原石已经准备好了！"</p>',
    tags: ['游戏', '原神', '新角色', '实机演示', '二次元'],
    isHot: true,
  },
];

export const getVideoById = (id: string) => {
  return videos.find((v) => v.id === id) || null;
};

export const getVideosByCategory = (categorySlug: string) => {
  return videos.filter((v) => v.category === categorySlug);
};

export const getHotVideos = () => {
  return videos.filter((v) => v.isHot);
};

export const getRelatedVideos = (video: Video, count: number = 4) => {
  return videos
    .filter((v) => v.id !== video.id && v.category === video.category)
    .slice(0, count);
};